import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    height: 36,
    padding: theme.spacing(0, 2),
    backgroundColor: theme.palette.grey[200],
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.grey[400],
  },
  addressBar: {
    flex: 1,
    maxWidth: 320,
    height: 20,
    marginLeft: theme.spacing(2),
    borderRadius: 10,
    backgroundColor: theme.palette.common.white,
  },
}))

export default useStyles
